import QueryState from '../query_state'
import { Alert, PageLayout } from '@cinesend/ui-kit'
import { useLocation, useNavigate } from 'react-router-dom'
import Tabs from './tabs'
import { ErrorBoundary } from 'react-error-boundary'

const SECTION_BY_SEGMENT = {
  dashboard: 'Cycle',
  details: 'Cycle',
  issues: 'Cycle',
  submission: 'Cycle',
  sections: 'Catalog',
  categories: 'Catalog',
  metadata: 'Catalog',
  images: 'Media',
  files: 'Media',
  ads: 'Advertising & Pre-roll',
  lists: 'Configuration',
}

function navSection(pathname) {
  if (pathname.startsWith('/settings')) return 'Administration'
  const match = pathname.match(/^\/airlines\/[^/]+\/cycles\/[^/]+\/([^/]+)/)
  return match ? (SECTION_BY_SEGMENT[match[1]] ?? null) : null
}

function ErrorFallback({ error }) {
  return (
    <Alert tone='error'>
      <div>
        <div className='text-xl font-bold'>{`Oops. Something went wrong.`}</div>
        {error.message && <div className='mt-2 text-xs'>{error.message}</div>}
        {error.stack && <pre className='mt-2 text-xs'>{error.stack}</pre>}
      </div>
    </Alert>
  )
}

const Page = ({
  title,
  buttons = [],
  breadcrumbs = [],
  tabs = [],
  headerExtra = null,
  pending = false,
  error = null,
  className,
  children,
}) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const section = navSection(pathname)
  const titleLabel = typeof title === 'string' ? title : null
  const trail = breadcrumbs.length > 0 ? breadcrumbs : titleLabel ? [{ text: titleLabel }] : []
  const crumbs = section && trail[0]?.text !== section ? [{ text: section }, ...trail] : trail
  const pageTitle = title ?? crumbs.at(-1)?.text ?? ''
  const content = (
    <>
      {tabs.length > 0 ? <Tabs list={tabs} /> : null}
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
    </>
  )

  return (
    <QueryState isLoading={pending} error={error} loadingClassName='min-h-screen'>
      <div className='min-w-0'>
        {pageTitle || crumbs.length > 0 ? (
          <PageLayout
            className={className}
            title={pageTitle}
            breadcrumbs={crumbs.map(({ text, to }) => ({
              label: text ?? '',
              onSelect: to ? () => navigate(to) : undefined,
            }))}
            description={headerExtra}
            actions={buttons?.length === 0 ? undefined : buttons}
          >
            {content}
          </PageLayout>
        ) : (
          content
        )}
      </div>
    </QueryState>
  )
}

export default Page
